export default {
  setTitle({commit}, data) {
    commit('setTitle', data)
  },
  setDialog({commit}, data) {
    commit('setDialog', data)
  },
  clearDialog({commit}, data) {
    commit('clearDialog', data)
  },
  updateHttpLoading({commit}, data) {
    commit('updateHttpLoading', data)
  },
  updateRouter({commit}, data) {
    commit('updateRouter', data)
  },
  // 微信签名配置
  updateWxSignature({
                      commit
                    }, data) {
    commit('updateWxSignature', data)
  },
  // 设置平台
  setPlatform({
                commit
              }, data) {
    commit('setPlatform', data)
  },
  setUserId({commit}, data) {
    commit('setUserId', data)
  },
}



// WEBPACK FOOTER //
// ./src/store/system/actions.js